<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/driver/information-queue" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Trip In Progress</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="top-informations">
      <div class="value-bigger" *ngIf="!race.raceType.includes('Round Trip')">
        <span>Trip Amount</span>
        <span style="color: black;">{{ race.valorCorrida | currency }}</span>
      </div>
      <div class="value-bigger" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 0">
        <span>Trip Amount</span>
        <span style="color: black;">{{ race.valorCorrida | currency }}</span>
      </div>
      <div class="data-user">
        <div class="block">
          <div class="ico">
            <ion-img src="assets/images/drive.png" />
          </div>
          <h3>{{ race.nomePassageiro }}</h3>
        </div>
        <p class="detail" style="color: black;"><ion-icon name="call"></ion-icon> {{ race.celular }}</p>
        <div class="payment-badge">
          <ion-badge color="primary" *ngIf="race?.pagaPelaPlataforma">Paid by Platform</ion-badge>
          <ion-badge color="success" *ngIf="!race?.pagaPelaPlataforma">Collect from Passenger</ion-badge>
        </div>
      </div>
    </div>
  <div class="informations-complementary">
    <div class="block full one green" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 1">
      <h4>Destination</h4>
      <p><ion-icon name="pin"></ion-icon> {{ race.enderecoOrigem }}</p>
    </div>
    <div class="block full one green" *ngIf="!race.raceType.includes('Round Trip')">
      <h4>Destination</h4>
      <p><ion-icon name="pin"></ion-icon> {{ race.enderecoDestino }}</p>
    </div>
    <div class="block full one green" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 0">
      <h4>Destination</h4>
      <p><ion-icon name="pin"></ion-icon> {{ race.enderecoDestino }}</p>
    </div>
    <div class="block" *ngIf="!race.raceType.includes('Round Trip')">
      <h4>Trip</h4>
      <p><ion-icon name="contract"></ion-icon> {{ race.raceType }}</p>
    </div>
    <div class="block" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 0">
      <h4>Trip</h4>
      <p><ion-icon name="contract"></ion-icon> {{ race.raceType }}</p>
    </div>
    <div class="block" *ngIf="!race.raceType.includes('Round Trip')">
      <h4>Transfer to GoSpread</h4>
      <p>
        <ion-icon name="cash"></ion-icon> {{ race.repasseMotorista | currency }}
      </p>
    </div>
    <div class="block" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 0">
      <h4>Transfer to GoSpread</h4>
      <p>
        <ion-icon name="cash"></ion-icon> {{ race.repasseMotorista | currency }}
      </p>
    </div>
    <div class="block full one" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 0">
      <h4>Trip Comments</h4>
      <p><ion-icon name="chatbox"></ion-icon> {{ race.observation }}</p>
    </div>
    <div class="block full one" *ngIf="!race.raceType.includes('Round Trip')">
      <h4>Trip Comments</h4>
      <p><ion-icon name="chatbox"></ion-icon> {{ race.observation }}</p>
    </div>
  </div>
  <div class="ion-padding buttons-locations" *ngIf="!race.raceType.includes('Round Trip')">
    <button class="button-location" (click)="navigate('Maps')">
      <ion-img src="assets/images/ico-gmaps.png" class="ico" />
      Google Maps
    </button>
    <button class="button-location" (click)="navigate('Waze')">
      <ion-img src="assets/images/ico-waze.png" class="ico" />
      Waze
    </button>
  </div>
  <div class="ion-padding buttons-locations" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 0">
    <button class="button-location" (click)="navigate('Maps')">
      <ion-img src="assets/images/ico-gmaps.png" class="ico" />
      Google Maps
    </button>
    <button class="button-location" (click)="navigate('Waze')">
      <ion-img src="assets/images/ico-waze.png" class="ico" />
      Waze
    </button>
  </div>
  <div class="ion-padding buttons-locations" *ngIf="race.etapaIdaVolta && race.etapaIdaVolta === 1">
    <button class="button-location" (click)="navigateRoundTripReturn('Maps')">
      <ion-img src="assets/images/ico-gmaps.png" class="ico" />
      Google Maps
    </button>
    <button class="button-location" (click)="navigateRoundTripReturn('Waze')">
      <ion-img src="assets/images/ico-waze.png" class="ico" />
      Waze
    </button>
  </div>
  <div class="ion-padding">
    <button class="button-bigger grey" (click)="finishRace()">
      <span class="decoration-alert">Drop Off</span>
    </button>
  </div>
</ion-content>